<div class="chat-message" [class.user]="isUser" [class.bot]="isBot" #chatMessage>
  <div
    class="message"
    [class.user]="isUser"
    [class.bot]="isBot && message?.type !== MessageFunctionType.Loading"
    [class.loading]="message?.type == MessageFunctionType.Loading"
  >
    <div class="message-actions" *ngIf="isBot && message?.type == MessageFunctionType.Table">
      <div
        class="download-button"
        [class.disabled]="isCopyIconDisabled"
        *ngIf="isBot && message?.type == MessageFunctionType.Table"
        (click)="download(message)"
      >
        <mat-icon svgIcon="download-icon-new"></mat-icon>
      </div>
    </div>
    <div class="message-content">
      <ng-container *ngIf="message?.type === MessageFunctionType.Loading; else messageContent">
        <div class="typing-animation">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </ng-container>
      <ng-template #messageContent>
        <miq-dynamic-chat-loader [message]="message"></miq-dynamic-chat-loader>

        <div class="feedback" *ngIf="isBot && message?.type !== MessageFunctionType.Loading">
          <p class="feedback-text" *ngIf="index === 1">
            {{ 'chat.feedbackText' | xTranslate }}
          </p>
          <div class="feedback-actions">
            <mat-icon
              class="feedback-icon"
              [ngClass]="{ selected: message.feedback === true }"
              [svgIcon]="message.feedback === true ? 'thumb_up_filled' : 'thumb_up'"
              (click)="giveFeedback(true)"
            >
            </mat-icon>
            <mat-icon
              class="feedback-icon"
              [ngClass]="{ selected: message.feedback === false }"
              [svgIcon]="message.feedback === false ? 'thumb_down_filled' : 'thumb_down'"
              (click)="giveFeedback(false)"
            >
            </mat-icon>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="initials" [class.user]="isUser" [class.bot]="isBot" *ngIf="message?.senderInitial">
    <ng-container *ngIf="isUser; else botIcon">
      {{ message?.senderInitial }}
    </ng-container>
    <ng-template #botIcon>
      <mat-icon class="ellis-avatar-icon" svgIcon="ellis-ai-avatar"></mat-icon>
    </ng-template>
  </div>
</div>
